import React from 'react'
import { Box } from '@mui/material'

const COLORS: Record<string, string> = {
    // campaign
    FREEZING: '#3b82f6', QUEUED: '#3b82f6', RUNNING: '#f59e0b', COMPLETED: '#10b981',
    COMPLETED_WITH_FAILURES: '#f59e0b', FAILED: '#ef4444', CANCELLED: '#9ca3af',
    // recipient
    PENDING: '#3b82f6', SENT: '#10b981', SKIPPED: '#f59e0b',
    // device delivery
    SENDING: '#3b82f6', ACCEPTED: '#10b981', FAILED_RETRYABLE: '#f59e0b', FAILED_PERMANENT: '#ef4444', EXHAUSTED: '#ef4444',
    // retry state
    NONE: '#9ca3af', SCHEDULED: '#3b82f6',
}

// "Accepted by Firebase" is deliberately NOT worded as "delivered".
const LABELS: Record<string, string> = {
    COMPLETED_WITH_FAILURES: 'Completed with failures',
    SENT: 'Accepted by Firebase',
    ACCEPTED: 'Accepted by Firebase',
    FAILED_RETRYABLE: 'Failed (will retry)',
    FAILED_PERMANENT: 'Failed (permanent)',
    EXHAUSTED: 'Retries exhausted',
    NONE: 'None',
}

const StatusPill: React.FC<{ status?: string | null }> = ({ status }) => {
    if (!status) return <span style={{ color: '#5a5a5a' }}>-</span>
    const color = COLORS[status] || '#9ca3af'
    return (
        <Box sx={{
            display: 'inline-flex', alignItems: 'center', gap: 0.6,
            px: 1.5, py: 0.4, borderRadius: '6px', fontSize: '11px', fontWeight: 700,
            color, backgroundColor: `${color}18`, border: `1px solid ${color}50`,
            letterSpacing: '0.03em', whiteSpace: 'nowrap', textTransform: 'uppercase',
        }}>
            <Box sx={{ width: 5, height: 5, borderRadius: '50%', background: color, flexShrink: 0 }} />
            {LABELS[status] ?? status.replace(/_/g, ' ')}
        </Box>
    )
}

export default StatusPill
